import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

// SSR-safe storage — falls back to a no-op during server-side rendering
const ssrSafeStorage = createJSONStorage(() => ({
  getItem: (name) => {
    if (typeof window === 'undefined') return null
    return localStorage.getItem(name)
  },
  setItem: (name, value) => {
    if (typeof window === 'undefined') return
    localStorage.setItem(name, value)
  },
  removeItem: (name) => {
    if (typeof window === 'undefined') return
    localStorage.removeItem(name)
  },
}))

export const useAuthStore = create(
  persist(
    (set) => ({
      user: null,
      token: null,
      isAuthenticated: false,

      setAuth: (user, token) => {
        if (typeof window !== 'undefined') localStorage.setItem('token', token)
        set({ user, token, isAuthenticated: true })
      },

      logout: () => {
        if (typeof window !== 'undefined') {
          localStorage.removeItem('token')
        }
        set({ user: null, token: null, isAuthenticated: false })
      },

      updateUser: (userData) => {
        set((state) => ({ user: { ...state.user, ...userData } }))
      },

      initializeAuth: () => {
        if (typeof window === 'undefined') return
        const token = localStorage.getItem('token')
        const storedAuth = localStorage.getItem('auth-storage')

        if (token && storedAuth) {
          try {
            const { state } = JSON.parse(storedAuth)
            if (state?.user && state?.isAuthenticated) {
              set({
                user: state.user,
                token: state.token || token,
                isAuthenticated: true
              })
            }
          } catch (error) {
            console.error('Error initializing auth:', error)
            localStorage.removeItem('token')
            localStorage.removeItem('auth-storage')
          }
        }
      },
    }),
    {
      name: 'auth-storage',
      storage: ssrSafeStorage,
    }
  )
)
